import type { ReactNode } from 'react';
import { UMIcon, UMR } from '../_components';

/** Bouton pleine largeur « Calculer … » : contour bleu, icône étincelle, atténué quand désactivé. */
export function CalcButton({ children, disabled, onClick }: { children: ReactNode; disabled?: boolean; onClick: () => void }) {
  return (
    <button type="button" disabled={disabled} onClick={onClick} style={{
      width: '100%', minHeight: 40, boxSizing: 'border-box', padding: '8px 16px',
      display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: 8,
      background: UMR.white, border: `1px solid ${UMR.blue}`, borderRadius: 0, color: UMR.blue,
      fontFamily: UMR.font, fontSize: 14, cursor: disabled ? 'not-allowed' : 'pointer', opacity: disabled ? 0.4 : 1,
    }}>
      <UMIcon name="auto_awesome" size={20} color={UMR.blue} />
      <span>{children}</span>
    </button>
  );
}
